module.exports = __webpack_public_path__ + "img/SKMJ_lift7.f076290a.jpg";